import './ProgramItem.css.proxy.js';
/* src/components/ProgramItem.svelte generated by Svelte v3.29.4 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	null_to_empty,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import Icon from "../../web_modules/fa-svelte.js";
import { IconMap, IconType } from "./data/icons.js";

function create_fragment(ctx) {
	let div1;
	let icon_1;
	let t0;
	let div0;
	let h4;
	let t1;
	let t2;
	let p;
	let div1_class_value;
	let current;

	icon_1 = new Icon({
			props: {
				icon: IconMap[/*icon*/ ctx[3]],
				class: "icon"
			}
		});

	return {
		c() {
			div1 = element("div");
			create_component(icon_1.$$.fragment);
			t0 = space();
			div0 = element("div");
			h4 = element("h4");
			t1 = text(/*title*/ ctx[0]);
			t2 = space();
			p = element("p");
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			claim_component(icon_1.$$.fragment, div1_nodes);
			t0 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			h4 = claim_element(div0_nodes, "H4", { class: true });
			var h4_nodes = children(h4);
			t1 = claim_text(h4_nodes, /*title*/ ctx[0]);
			h4_nodes.forEach(detach);
			t2 = claim_space(div0_nodes);
			p = claim_element(div0_nodes, "P", { class: true });
			var p_nodes = children(p);
			p_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h4, "class", "svelte-b8mxgm");
			attr(p, "class", "svelte-b8mxgm");
			attr(div0, "class", "svelte-b8mxgm");
			attr(div1, "class", div1_class_value = "" + (null_to_empty(/*bg*/ ctx[2] ? "bg program-item" : "program-item") + " svelte-b8mxgm"));
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			mount_component(icon_1, div1, null);
			append(div1, t0);
			append(div1, div0);
			append(div0, h4);
			append(h4, t1);
			append(div0, t2);
			append(div0, p);
			p.innerHTML = /*content*/ ctx[1];
			current = true;
		},
		p(ctx, [dirty]) {
			const icon_1_changes = {};
			if (dirty & /*icon*/ 8) icon_1_changes.icon = IconMap[/*icon*/ ctx[3]];
			icon_1.$set(icon_1_changes);
			if (!current || dirty & /*title*/ 1) set_data(t1, /*title*/ ctx[0]);
			if (!current || dirty & /*content*/ 2) p.innerHTML = /*content*/ ctx[1];;

			if (!current || dirty & /*bg*/ 4 && div1_class_value !== (div1_class_value = "" + (null_to_empty(/*bg*/ ctx[2] ? "bg program-item" : "program-item") + " svelte-b8mxgm"))) {
				attr(div1, "class", div1_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(icon_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(icon_1);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { title } = $$props,
		{ content } = $$props,
		{ bg = true } = $$props,
		{ icon = IconType.other } = $$props;

	$$self.$$set = $$props => {
		if ("title" in $$props) $$invalidate(0, title = $$props.title);
		if ("content" in $$props) $$invalidate(1, content = $$props.content);
		if ("bg" in $$props) $$invalidate(2, bg = $$props.bg);
		if ("icon" in $$props) $$invalidate(3, icon = $$props.icon);
	};

	return [title, content, bg, icon];
}

class ProgramItem extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { title: 0, content: 1, bg: 2, icon: 3 });
	}
}

export default ProgramItem;
//# sourceMappingURL=ProgramItem.js.map
